import React from 'react';
import { useIntl } from 'react-intl';

import { LoadingWizardScreen } from '@futrli/ui-components/components/sidebar/wizard/screens/loading-wizard-screen/loading-wizard-screen';

export const ReclassifyLoadingScreen = () => {
  const intl = useIntl();

  return (
    <LoadingWizardScreen
      text={intl.formatMessage({
        id: 'predict.forecasting.saving_changes',
        defaultMessage: 'Saving changes...'
      })}
    />
  );
};
